<template>
  <div class="cardList">
    <template>
      <div @click="heidClick('edit',item)" class="card_box" v-for="(item,index) in carList" :key="index">
        <el-image class="img_box" fit="cover" :src="item.image"></el-image>
        <div>{{ item.name }}</div>
      </div>
      <div @click="heidClick('add')" class="car_inbox" v-if="carList.length<=22 && addShow">
        <i class="el-icon-plus"></i>
      </div>
    </template>
    <el-dialog
        title="新增/编辑塔牌"
        :visible.sync="dialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <div class="tart_box">
            <div class="left_box">
              <div class="diplay" style="margin-bottom: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in coverImgList"
                    :key="index"
                    class="slideshow"
                    @click="getPolicy('cover')"
                >
                  <el-image
                      style="width: 132px; height: 227px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                  />
                </span>
                  <div
                      class="up-btn"
                      style="width: 132px; height: 227px; line-height: 227px"
                      @click="getPolicy('cover')"
                      v-if="isCoverMoer"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="cover"
                    @change="getFile('cover')"
                    accept="image/png,image/jpg"
                />
              </div>
              <el-input
                  placeholder="请输入塔牌名称"
                  v-model="tarotCar.name"
                  style="width:132px;margin-right: 5px"
              ></el-input>
            </div>
            <div class="right_box">
              <div class="tag_box">
                <div class="tag_name">分类：</div>
                <div class="tag_content_box">
                  <div @click="changBoxInfo(item,'type')" class="info_content" :class="{'active_content':params.tarotCategoryId==item.tarotCategoryId}"
                       v-for="(item,index) in tableData" :key="index">{{ item.name }}
                  </div>
                </div>
              </div>
              <div class="tag_box">
                <div class="tag_name">阶段：</div>
                <div class="tag_content_box">
                  <div class="info_content" @click="changBoxInfo(item,'stage')" :class="{'active_content':params.stage==item.stage}"
                       v-for="(item,index) in stageList" :key="index">{{ item.name }}
                  </div>
                </div>
              </div>
              <div class="tag_box">
                <div class="tag_name">状态：</div>
                <div class="tag_content_box">
                  <div class="info_content" @click="changBoxInfo(item,'direction')" :class="{'active_content':params.direction==item.direction}"
                       v-for="(item,index) in directionList" :key="index">{{ item.name }}
                  </div>
                </div>
              </div>
              <div class="content_title_set">内容设置</div>
              <el-form-item label="关键字" prop="guideDescr">
                <el-input
                    placeholder="请输入关键字"
                    v-model="params.keyword"
                ></el-input>
              </el-form-item>
              <el-form-item label="牌面含义" prop="subject">
                <el-input
                    type="textarea"
                    placeholder="请填写牌面含义"
                    :rows="8"
                    v-model="params.descr"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="问题解答" prop="subject">
                <el-input
                    type="textarea"
                    :rows="8"
                    placeholder="请填写问题解答"
                    v-model="params.result"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit('none')"
        >仅保存</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit('close')"
        >保存并关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {ossUpload} from "@utils/filters/upload";
export default {
  name: "CardFaceList",
  data() {
    return {
      carList: [],
      dialogVisible: false,
      rules: {},
      //解释内容
      params: {
        direction: 1,
        keyword: '',
        descr:'',
        result:'',
        stage: 1,
        tarotId:'',
        tarotCategoryId: ''
      },
      //牌的内容
      tarotCar:{
        image:'',
        name:''
      },
      coverImgList: [],
      isCoverMoer: true,
      stageList: [
        {
          name: '现在',
          stage: '1'
        },
        {
          name: '阻碍',
          stage: '2'
        },
        {
          name: '指引',
          stage: '3'
        }
      ],
      directionList: [
        {
          name: '正位',
          direction: '1'
        },
        {
          name: '逆位',
          direction: '2'
        },
      ],
      searchBox: {},
      tableData: [],
      changCar:false,
      submitType:'',
      oldImg:'',
      oldName:'',
      addShow:false
    }
  },
  mounted() {
    this.getCarList()
    this.queryStyleData()
    this.getPermissionButtonList()
  },

  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'tarot:info:add') {
            this.addShow = true
          }
        })
      }
    },

    handleEdit(e){
      if(this.verificationInfo()){
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {

            if (this.submitType == "add") {
              const { data: resutData } = await this.$post(
                  "/tarot",
                  this.tarotCar,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resutData.result != 200) return;
              this.params.tarotId = resutData.data
              const { data: resData } = await this.$post(
                  "/tarot/info",
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.getCarList()
              // this.queryStyleData()
              this.$message.success("添加成功!");
            }
            if (this.submitType == "edit") {
              const { data: resData } = await this.$post(
                  "/tarot/info",
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              if(this.tarotCar.image!=this.oldImg || this.oldName != this.tarotCar.name){
                const { data: resutData } = await this.$put(
                    "/tarot",
                    this.tarotCar,
                    {
                      headers: {
                        isLoading: true,
                      },
                    }
                );
                if (resutData.result != 200) return;
              }
              this.$message.success("修改成功!");
            }
            if(e=='close'){
              this.getCarList()
              // this.queryStyleData()
              this.dialogVisible = false
            }
          });
        });
      }
    },
    verificationInfo(){
      let str = ''
      if(!this.tarotCar.image){
        this.$message.warning('请上传塔罗图片')
        str = false
      }else if(!this.tarotCar.name){
        this.$message.warning('请填写塔罗名称')
        str = false
      }else if(!this.params.keyword){
        this.$message.warning('请填写关键字')
        str = false
      }else if(!this.params.descr){
        this.$message.warning('请填写牌面含义')
        str = false
      }else if(!this.params.result){
        this.$message.warning('请填写问题解答')
        str = false
      }else {
        str = true
      }
      return str
    },
    changBoxInfo(item,e){
      this.params.keyword = ''
      this.params.descr = ''
      this.params.result = ''
      if(e=='type'){
         this.params.tarotCategoryId = item.tarotCategoryId
      }else if(e=='stage'){
        this.params.stage = item.stage
      }else if(e=='direction'){
        this.params.direction = item.direction
      }
      this.getTarotInfo(this.tarotCar)
    },
    async heidClick(e,item){
      this.submitType = e
      if(e=='edit'){
        this.loading = true;
        this.tarotCar = item
        this.coverImgList[0] = item.image
        this.isCoverMoer = false
        this.oldImg = item.image
        this.oldName = item.name
        this.params.direction = 1
        this.params.stage = 1
        this.params.tarotCategoryId = this.tableData[0].tarotCategoryId
        this.getTarotInfo(item)
      }else {
        this.params.keyword = ''
        this.params.descr = ''
        this.params.result = ''
        this.tarotCar.image = ''
        this.tarotCar.name = ''
        this.coverImgList = []
        this.isCoverMoer = true
      }
      this.dialogVisible = true
    },
    //获取牌面解释详情
    async getTarotInfo(item){
      let obj = {
        direction:this.params.direction,
        tarotCategoryId:this.params.tarotCategoryId,
        stage:this.params.stage,
        tarotId:item.tarotId,
      }
      const {data: resData} = await this.$get("/tarot/info",{
        params: {
          ...obj,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.params.tarotId = item.tarotId
      if(resData.data){
        this.params = resData.data
      }

    },
    //获取分类列表
    async queryStyleData() {
      this.loading = true;
      const {data: resData} = await this.$get("/tarot/category/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data
      this.params.tarotCategoryId = resData.data[0].tarotCategoryId
    },
    //图片上传
    getPolicy(e) {
      this.$refs[e].dispatchEvent(new MouseEvent("click"));
    },

    async getFile(e) {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs[e].files[0],
          resData.data,
          "one", //'more','one'
      );
      if (e == 'cover') {
        this.isCoverMoer = false;
        this.coverImgList = addRoutes;
        this.tarotCar.image = addRoutes[0];
      }
    },
    //获取分类列表
    async getCarList() {
      this.loading = true;
      const {data: resData} = await this.$get("tarot/list");
      this.loading = false;
      if (resData.result != 200) return;
      this.carList = resData.data
    },
  }
}
</script>

<style scoped lang="scss">
.cardList {
  display: flex;
  flex-wrap: wrap;

  .card_box {
    margin-right: 10px;
    margin-bottom: 10px;
    text-align: center;

    .img_box {
      width: 132px;
      height: 227px;
      margin-bottom: 5px;
    }
  }

  .car_inbox {
    width: 132px;
    height: 227px;
    border: 1px dashed #000000;
    border-radius: 5px;
    text-align: center;

    .el-icon-plus {
      font-size: 25px;
      font-weight: 200;
      line-height: 227px;
    }
  }
}

.tart_box {
  display: flex;

  .left_box {
    width: 142px;
    margin-right: 10px;
  }

  .right_box {
    cursor: pointer;
    width: calc(100% - 152px);

    .tag_box {
      display: flex;
      .tag_name {
        font-size: 18px;
      }

      .tag_content_box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .info_content {
          margin-bottom: 15px;
          font-size: 12px;
          margin-right: 15px;
          padding: 3px 5px;
          border-radius: 5px;
          border: 1px solid #959595;
          box-sizing: border-box;
        }

        .active_content {
          background: #3a8ee6;
          color: #ffffff;
          border-color: #3a8ee6;
        }
      }
    }

    .content_title_set {
      padding: 3px;
      border-bottom: 1px solid #959595;
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>